'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECTORS = exports.CLASSES = exports.CHECKS = undefined;

var _underscore = require('underscore');

var CHECKS = exports.CHECKS = {
  VISITOR_SUCCESS: 'visitor-success',
  VISITOR_ERROR: 'visitor-error'
};

var CLASSES = exports.CLASSES = {
  VISITOR_SUCCESS: 'reagan--visitor-success',
  VISITOR_ERROR: 'reagan--visitor-error'
};

var SELECTORS = exports.SELECTORS = (0, _underscore.mapObject)(CLASSES, function (cssClass) {
  return '.' + cssClass;
});


//////////////////
// WEBPACK FOOTER
// ./js/constants/Reagan.js
// module id = 192
// module chunks = 0 1